module.exports = __webpack_public_path__ + "img/icon_1_3.4b942f20.png";